/**
 * M-QC2 · Use it sends the pill to the composer (07 Workshop, motion board).
 * Use it notes where the pop-up's name sat; the pill that lands in the
 * composer for that pick starts there and travels to its place (120 to 480ms,
 * ease in out). With reduced motion it fades in where it lands, 160ms. A
 * flight nobody picks up within a second is dropped.
 */
type Flight = { rect: DOMRect; at: number };

const flights = new Map<string, Flight>();
const MAX_AGE_MS = 1000;

export function launchCreoFlight(id: string, from: Element | null): void {
  if (from) flights.set(id, { rect: from.getBoundingClientRect(), at: performance.now() });
}

/** Lands the pill if a flight for it is waiting. */
export function landCreoFlight(id: string, pill: HTMLElement): void {
  const flight = flights.get(id);
  flights.delete(id);
  if (!flight || performance.now() - flight.at > MAX_AGE_MS || typeof pill.animate !== "function") return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    pill.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 160, easing: "linear" });
    return;
  }
  const to = pill.getBoundingClientRect();
  const dx = flight.rect.left - to.left;
  const dy = flight.rect.top + flight.rect.height / 2 - (to.top + to.height / 2);
  pill.animate(
    [
      { transform: `translate(${dx}px, ${dy}px)`, opacity: 0 },
      { transform: `translate(${dx}px, ${dy}px)`, opacity: 1, offset: 0.05 },
      { transform: "none", opacity: 1 },
    ],
    { duration: 360, delay: 120, easing: "cubic-bezier(0.83, 0, 0.17, 1)", fill: "backwards" },
  );
}
